import axios from 'axios'
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {ENV} from '../../Utils/_helpers/EnvHelper'
import {toast} from 'react-toastify'

const API_URL = ENV().REACT_APP_API_URL
const initialState: any = {
  adminData: [],
}

///////////////////////////////////////////////////////////ADMIN AUTH ////////////////////////////////////

export const AdminSigninData: any = createAsyncThunk('AdminSigninData', async (data, thunkApi) => {
  const response = await axios.post(`${API_URL}auth/admin/login`, data, {})
  return response.data
})

export const adminLoginBackToAdmin: any = createAsyncThunk(
  'adminLoginBackToAdmin',
  async (data, thunkApi) => {
    const response = await axios.get(`${API_URL}admin/loginBackToAdmin`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    return response.data
  }
)

export const adminLoginAsStaff: any = createAsyncThunk(
  'admin/loginAsStaff',
  async (data, thunkApi) => {
    const response = await axios.post(`${API_URL}admin/loginAsStaff`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    return response.data
  }
)

const AdminAuth = createSlice({
  name: 'AdminAuth',
  initialState,
  reducers: {},
  extraReducers: {
    [AdminSigninData.fulfilled]: (state, {payload}) => {
      localStorage.setItem('isAdmin', 'true')
      localStorage.setItem('isAdminAsUser', 'false')
      localStorage.setItem('permission', JSON.stringify(payload?.data?.userPermissions))
      localStorage.setItem('AdminUser', JSON.stringify(payload))
      localStorage.setItem('role', JSON.stringify(payload?.data?.user?.role))
      localStorage.setItem('token', payload.data?.token)

      return {...state, adminData: payload}
    },
    [adminLoginBackToAdmin.fulfilled]: (state, {payload}) => {
      localStorage.setItem('isAdmin', 'true')
      localStorage.setItem('isAdminAsUser', 'false')
      localStorage.setItem('isAdminAsStaff', 'false')
      localStorage.setItem('permission', JSON.stringify(payload?.data?.userPermissions))
      localStorage.setItem('AdminUser', JSON.stringify(payload))
      localStorage.setItem('role', JSON.stringify(payload?.data?.user?.role))
      localStorage.setItem('token', payload.data?.token)
      localStorage.setItem('isAdminAsUserRefresh', 'false')
      return {...state, adminData: payload}
    },
    [adminLoginAsStaff.fulfilled]: (state, {payload}) => {
      const adminUser = localStorage.getItem('AdminUser') || ''
      localStorage.setItem('superAdminUser', adminUser as string)
      localStorage.setItem('isAdminAsStaff', 'true')
      localStorage.setItem('isAdminAsUser', 'false')
      localStorage.setItem('permission', JSON.stringify(payload?.data?.userPermissions))
      localStorage.setItem('AdminUser', JSON.stringify(payload))
      localStorage.setItem('role', JSON.stringify(payload?.data?.user?.role))
      localStorage.setItem('token', payload.data?.token)
      localStorage.setItem('isAdminAsUserRefresh', 'false')

      toast.success(payload.message)

      return {...state, adminData: payload}
    },
  },
})

export default AdminAuth.reducer
